import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';

import styles from './index.module.css';

export const FilterCard = ({
  toggleDrawer,
  selectedQuantity,
  cardTitleTextKey
}) => {
  const { t } = useI18n();

  return (
    <Box className={styles.filterCard} onClick={toggleDrawer}>
      <AText
        size="m"
        color="txt_color_1"
        transform="uppercase"
        className={styles.cardTitle}
      >
        {t(cardTitleTextKey)}
      </AText>
      <Box align="center">
        {selectedQuantity ? (
          <Box align="center" className={styles.cardRightText}>
            <AText size="m" color="txt_color_1">
              {`${t('web.games.search.filters.selected')}:`}
            </AText>
            <AText
              breed="BU"
              size="m"
              color="txt_color_1"
              className={styles.cardTextQuantity}
            >
              {selectedQuantity}
            </AText>
          </Box>
        ) : null}
        <Icon
          name="icons/general/nav/arrow-down"
          size="m"
          color="line_header_txt"
        />
      </Box>
    </Box>
  );
};
